import React, { useEffect } from "react";
import _ from 'underscore';
import { Form, Input, DatePicker, Icon, Select, Button, Checkbox, message, Table } from 'antd';
import moment from 'moment';
import sortOrder from './utils/sortOrder';
import filter from './utils/filter';

const { Option } = Select;

const datePickerFormat = 'MMM Do YYYY'
const timePickerFormat = 'h:mmA';
const by = 'resourceCollection';

const ApprovalFindByResourceCollectionForm = ({ resourceCollection, requestDates, resourceCollectionList, ...props }) => {

  const { getFieldDecorator, getFieldsError, getFieldsValue } = props.form;

  useEffect(() => { // set form values
    const form = props.form;
    form.setFieldsValue({
      fromDate: requestDates.fromDate ? moment(requestDates.fromDate).startOf('day') : moment().startOf('day'),
      toDate: requestDates.toDate ? moment(requestDates.toDate).startOf('day') : moment().startOf('day'),
      selectedResourceCollection: resourceCollection.resourceCollectionName
    });
  }, [requestDates, resourceCollection]);

  const invalidForm = () => {
    message.config({
      top: 150,
      duration: 5,
      maxCount: 5,
    });
    message.error('You have one or more invalid form inputs!');
  };

  const validateForm = () => { // validates the whole form
    const form = props.form;

    const fromDate = form.getFieldValue('fromDate') ? form.getFieldValue('fromDate').startOf('day').clone() : null;
    const toDate = form.getFieldValue('toDate') ? form.getFieldValue('toDate').startOf('day').clone() : null;

    let fromDateErrors = [];
    if (!fromDate) {
      fromDateErrors.push(new Error('Please input start date!'));
    }
    if (fromDate && toDate && toDate.isBefore(fromDate)) {
      fromDateErrors.push(new Error('Start date cannot occur after end date!'));
    }

    if (fromDateErrors.length > 0) {
      form.setFields({
        fromDate: {
          value: fromDate,
          errors: fromDateErrors,
        }
      });
    } else {
      form.setFields({
        fromDate: {
          value: fromDate,
        }
      });
    }

    let toDateErrors = [];
    if (!toDate) {
      toDateErrors.push(new Error('Please input end date!'));
    }
    if (toDate && fromDate && fromDate.isAfter(toDate)) {
      toDateErrors.push(new Error('End date cannot occur before start date!'));
    }
    if (toDateErrors.length > 0) {
      form.setFields({
        toDate: {
          value: toDate,
          errors: toDateErrors,
        }
      });
    } else {
      form.setFields({
        toDate: {
          value: toDate,
        }
      });
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = {};
    // collect all fields currently in error state
    for (const [field, error] of Object.entries(getFieldsError())) {
      if (error) {
        errors[`${field}`] = error;
      }
    }
    if (Object.values(errors).length === 0) {
      let formValues = getFieldsValue();
      formValues.selectedResourceCollection = resourceCollection;
      console.log('Success! Received values of form: ', formValues)
      props.searchByResourceCollection(formValues, by);
    } else {
      invalidForm();
      console.log('Invalid Form! ', errors);
    }
  }

  return (
    <Form
      onSubmit={(e) => handleSubmit(e)}>
      <Form.Item
        label="From Date"
        style={{ marginBottom: 5 }}
      >
        {getFieldDecorator('fromDate', {
          rules: [
            {
              required: true,
              message: 'Please input start date!'
            },
          ],
        })(
          <DatePicker
            name="fromDate"
            // showTime={{ format: datePickerFormat, use12Hours: true }}
            onChange={(e) => props.handleFromDateChange(e, validateForm)}
            allowClear={false}
            placeholder={'Select date and time'}
            format={datePickerFormat}
            size={'large'}
            popupStyle={{ zIndex: 2000 }}
          />
        )}
      </Form.Item>

      <Form.Item
        label="To Date"
        style={{ marginBottom: 5 }}
      >
        {getFieldDecorator('toDate', {
          rules: [
            {
              required: true,
              message: 'Please input start date!'
            },
          ],
        })(
          <DatePicker
            name="toDate"
            // showTime={{ format: datePickerFormat, use12Hours: true }}
            onChange={(e) => props.handleToDateChange(e, validateForm)}
            allowClear={false}
            placeholder={'Select date and time'}
            format={datePickerFormat}
            size={'large'}
            popupStyle={{ zIndex: 2000 }}
          />
        )}
      </Form.Item>

      {/* Resource Collection Search */}
      <Form.Item
        label="Resource Collection"
        style={{ marginBottom: 5 }}
      >
        {getFieldDecorator('selectedResourceCollection', {
          initialValue: resourceCollection.resourceCollectionName,
          rules: [
            {
              required: true,
              message: 'Please input a resource collection!'
            },
          ],
        })(
          <Input
            type="text"
            name="searchValue"
            placeholder={'Select a Schedule'}
            onChange={props.handleResourceCollectionSearch}
            size={'large'}
            required
          ></Input>
        )}
      </Form.Item>

      <Table
        columns={[
          {
            title: 'Live Schedules',
            dataIndex: 'name',
            render: text => <a>{text}</a>
          }
        ]}
        dataSource={resourceCollectionList}
        size="small"
        onRow={record => ({
          onClick: (e) => props.handleResourceCollectionChange(e, record)
        })}
      />

      <Form.Item
        label="Filter"
        style={{ marginBottom: 5 }}
      >
        {getFieldDecorator('filter', {
          initialValue: filter[0].value || null,
          rules: [{
            required: true, message: 'Please input a status!',
          }],
        })(
          <Select
            name='filter'
            allowClear={false}
            style={{ width: 250 }}
            dropdownStyle={{ zIndex: 2000 }}
          >
            {filter.map((filterOption, index) => {
              return <Option key={'filterOption' + index} value={filterOption.value} >{filterOption.name}</Option>
            })}
          </Select>
        )}
      </Form.Item>

      <Form.Item
        label="Sort Order"
        style={{ marginBottom: 5 }}
      >
        {getFieldDecorator('sortOrder', {
          initialValue: sortOrder[0].value || null,
          rules: [{
            required: true, message: 'Please input a sort order!',
          }],
        })(
          <Select
            name='sortOrder'
            allowClear={false}
            style={{ width: 250 }}
            dropdownStyle={{ zIndex: 2000 }}
          >
            {sortOrder.map((sortOption, index) => {
              return <Option key={'sortOption' + index} value={sortOption.value} >{sortOption.name}</Option>
            })}
          </Select>
        )}
      </Form.Item>

      <Form.Item
        style={{ marginBottom: 24 }}
      >
        {getFieldDecorator('sortByCostObject', {
          initialValue: false,
        })(
          <Checkbox name='sortByCostObject'>
            Sort By Cost Object
          </Checkbox>
        )}
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form >
  );
}

const WrappedApprovalFindByResourceCollectionForm = Form.create()(ApprovalFindByResourceCollectionForm);
export default WrappedApprovalFindByResourceCollectionForm;



// WEBPACK FOOTER //
// ./src/Components/Approval/ApprovalFindByResourceCollectionForm.js